import { IContracts, IListableContractsRaw, ITermsContractRaw } from '../entities/contracts/types';
import { IConfiguredHttp } from './http';

export interface IContractApi {
	getChannelsForCustomer: (customerId: string) => Promise<IContracts>;
	updateChannelsForCustomer: (customerId: string, contracts: IContracts) => Promise<IListableContractsRaw[]>;
	getTermsForCustomer: (customerId: string) => Promise<IContracts>;
	updateTermsForCustomer: (customerId: string, contracts: IContracts) => Promise<ITermsContractRaw[]>;
}

const contractApiFactory = (http: IConfiguredHttp, prefix = ''): IContractApi => ({
	getChannelsForCustomer(customerId: string) {
		return http.get(`${prefix}/channels/customer/${customerId}`);
	},
	updateChannelsForCustomer(customerId: string, contracts: IContracts) {
		return http.put(`${prefix}/channels/customer/${customerId}`, contracts);
	},
	getTermsForCustomer(customerId: string) {
		return http.get(`${prefix}/terms/customer/${customerId}`);
	},
	updateTermsForCustomer(customerId: string, contracts: IContracts) {
		return http.put(`${prefix}/terms/customer/${customerId}`, contracts);
	}
});

export default contractApiFactory;
